export function downloadFile(url: string, fileName?: string) {
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName || getPathFileName(a.pathname);
  a.click();
}

export function getPathFileName(path: string): string {
  const lastSlash = path.lastIndexOf('/');
  return lastSlash >= 0 ? path.substr(lastSlash + 1) : path;
}